import PropTypes from 'prop-types';

import React from 'react';
import { Map } from 'immutable';

import schema from '../../schema/index.json';

import BlockControlsContainer from '../../containers/BlockControlsContainer';
import BlockOrder from '../BlockOrder';
import Errors from '../Errors';
import UploadProgress from '../ui/UploadProgress';

import Text from '../blocks/Text';
import Collapse from '../blocks/Collapse';
import Image from '../blocks/Image';
import Video from '../blocks/Video';
import Quote from '../blocks/Quote';
import Widget from '../blocks/Widget';
import Galleries from '../../containers/Galleries';
import ARs from '../../containers/ARs';

import Wrapper from './Wrapper';
import Inner from './Inner';
import Content from './Content';
import ContentInner from './ContentInner';

const blockComponents = {
  TEXT: Text,
  COLLAPSE: Collapse,
  IMAGE: Image,
  VIDEO: Video,
  QUOTE: Quote,
  WIDGET: Widget,
  GALLERY: Galleries,
  AR: ARs,
};

function Block(props) {
  const BlockWrapper = blockComponents[props.type];
  if (!BlockWrapper) return null;

  return (
    <Wrapper>
      <Inner>
        <BlockOrder
          index={props.index + 1}
          maxIndex={props.maxIndex}
          isActive={props.active}
          isValid={props.block.get('isValid')}
          connectDragSource={props.connectDragSource}
          onIndexChange={props.onIndexChange}
        />

        <Content>
          <ContentInner>
            {props.block.get('uploading') && <UploadProgress />}

            <Errors errorMessages={props.block.get('errors')} />

            <BlockWrapper
              block={props.block}
              allowedBlockTypes={props.allowedBlockTypes}
              postType={props.postType}
              onChangeBlockField={props.onChangeBlockField}
              onChangeBlockType={props.onChangeBlockType}
              onDropFile={props.onDropFile}
              onRemoveMedia={props.onRemoveMedia}
              onRemoveSpelling={props.onRemoveSpelling}
            />
          </ContentInner>
        </Content>

        <BlockControlsContainer
          block={props.block}
          readOnly={props.readOnly}
          onRemove={props.onRemove}
        />
      </Inner>
    </Wrapper>
  );
}

Block.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,
  type: PropTypes.oneOf(Object.keys(schema.definitions)),
  index: PropTypes.number.isRequired,
  maxIndex: PropTypes.number,
  active: PropTypes.bool,
  readOnly: PropTypes.bool,
  allowedBlockTypes: PropTypes.array,
  postType: PropTypes.oneOf(['short', 'longread']),

  onChangeBlockField: PropTypes.func.isRequired,
  onChangeBlockType: PropTypes.func.isRequired,
  onDropFile: PropTypes.func,
  onRemoveMedia: PropTypes.func,
  onRemoveSpelling: PropTypes.func,
  onRemove: PropTypes.func,
  onIndexChange: PropTypes.func,
  connectDragSource: PropTypes.func.isRequired,
};

export default Block;
